import React, { useState, useEffect } from 'react';
// import { useClickOutside } from '../../_hooks';
import { Button, Icon, IconButton } from '..';
import {
  RelatedArticleSearch,
  RelatedCharacterItem,
  RelatedOrganizationItem,
  RelatedLocationItem,
  RelatedArticleItem,
} from './';

// const ChosenArticle = RenderedArticleInterface[articleType];
// <ChosenArticle article={article} />

export function RelatedArticlePicker({ value = [], onChange, articleType }) {
  // console.log('INITIAL VALUE', value);
  const [isInputShown, setInputShown] = useState(false);
  const [selectedArticles, setSelectedArticles] = useState(value);

  const RenderedArticleInterface = {
    character: RelatedCharacterItem,
    organization: RelatedOrganizationItem,
    location: RelatedLocationItem,
    article: RelatedArticleItem,
  };
  const toggleInput = (shown) => {
    if (shown !== undefined) {
      setInputShown(shown);
    } else {
      setInputShown((prev) => !prev);
    }
  };

  const handleArticleSelect = (article) => {
    const foundInCollection = selectedArticles.find(
      (a) => a.waID === article.id
    );
    if (foundInCollection) {
      setSelectedArticles((prev) => prev.filter((a) => a.waID !== article.id));
    } else {
      // console.log('Article', article);
      const articleData = {
        waID: article.id || '',
        type: article.template || '',
        subtype: article.subtype || '',
        link: article.url || '',
        cover: article.cover || '',
        title: article.title || '',
        excerpt: article.excerpt || '',
        tags:
          article.tags && article.tags.length > 0
            ? article.tags.split(',')
            : [],
      };
      setSelectedArticles((prev) => [...prev, articleData]);
    }
    // console.log('Article: ', article);
  };

  const handleRemoveArticle = (article) => {
    // console.log('RM', article, selectedArticles);
    setSelectedArticles((prev) => prev.filter((p) => p.waID !== article.waID));
  };

  useEffect(() => {
    if (onChange) onChange(selectedArticles);
  }, [onChange, selectedArticles]);

  // const ChosenArticle =
  //   RenderedArticleInterface[articleType] || RelatedArticleItem;

  return (
    <div className="chronos-related-article-picker">
      <div className="chronos-related-articles-wrapper">
        {/* {selectedArticles &&
          selectedArticles.map((a) => (
            <ChosenArticle article={a} key={a.waID} />
          ))} */}
        {selectedArticles &&
          selectedArticles.map((a) => {
            const ChosenArticle =
              RenderedArticleInterface[a.type] || RelatedArticleItem;
            return (
              <ChosenArticle
                article={a}
                key={a.waID}
                onClick={handleRemoveArticle}
                isRemovable
              />
            );
          })}
      </div>
      <div className="chronos-related-articles-controls">
        {isInputShown && (
          <RelatedArticleSearch
            articleType={articleType}
            onCancel={() => toggleInput(false)}
            onSelect={handleArticleSelect}
          />
        )}
        {!isInputShown && (
          <Button color="primary" onClick={toggleInput}>
            <Icon icon="far fa-plus fa-fw" />
            &nbsp;Link Article
          </Button>
        )}
      </div>
    </div>
  );
}
